import type { GoodsItem } from '../components/VipPaymentModal/types'

export type ClawPlanKind = 'starter' | 'standard' | 'flagship'

/** 测试环境统一使用的 goodsID */
const TEST_GOODS_ID = '2034570013398134784'
const isProd = process.env.NODE_ENV === 'production'

/**
 * Claw 商品数据
 * 测试环境：统一使用测试 goodsID
 * 正式环境：使用各套餐对应的真实 goodsID
 */
export const CLAW_GOODS: Record<ClawPlanKind, GoodsItem> = {
  starter: {
    id: isProd ? '2034521336432422912' : TEST_GOODS_ID,
    price: 99,
    type: 1,
    content: {
      title: '小虾 Claw 入门版',
      subTitle: '适合小型团队入门使用',
      vipType: 1,
      vipKind: 101,
      pricePerMonth: 99,
      sign: '',
      monthCnt: 1
    }
  },
  standard: {
    id: isProd ? '2034521776507187200' : TEST_GOODS_ID,
    price: 399,
    type: 1,
    content: {
      title: '中虾 Claw 标准版',
      subTitle: '适合中型团队全面使用',
      vipType: 1,
      vipKind: 102,
      pricePerMonth: 399,
      sign: '最受欢迎',
      monthCnt: 1
    }
  },
  flagship: {
    id: isProd ? '2034521923072946176' : TEST_GOODS_ID,
    price: 999,
    type: 1,
    content: {
      title: '大虾 Claw 旗舰版',
      subTitle: '适合大型团队深度定制',
      vipType: 1,
      vipKind: 103,
      pricePerMonth: 999,
      sign: '尊享服务',
      monthCnt: 1
    }
  }
}

/** 根据 planKey 获取对应的 GoodsItem */
export function getClawGoods(planKey: ClawPlanKind): GoodsItem | null {
  return CLAW_GOODS[planKey] || null
}
